import {AppTourService} from '../../services/app-tour/app-tour.service';
import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {timeZonesData} from '../../config/data/time-zones/time-zones.data';
import {ICardDateAppointment, ICardIconText} from '../../interfaces/card';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {cloneDeep} from 'lodash';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {AppointmentActions, AppointmentState, AppointmentTypeEnum} from '../../models/appointment';
import {ModalAddPatientAppointmentComponent} from '../modal-add-patient-appointment/modal-add-patient-appointment.component';
import {IPatient, PatientAction, PatientState} from '../../models/patient';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable, Subscription} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';
import {take} from 'rxjs/operators';
import {ClinicBranchState, IClinicBranch} from '../../models/clinic-branch';
import {ExpertAction, IExpert} from '../../models/expert';
import {ClinicActions, ClinicState, IClinicalObjective} from '../../models/clinic';
import {ModalAddExpertAppointmentComponent} from '../modal-add-expert-appointment/modal-add-expert-appointment.component';
import {DateComponent} from '../date-component/date-component.component';
import {IAvailableSpot, IDateInterface, IGeneratedBlocks} from '../../interfaces/date';
import {Logger} from '../../class/helper/logger.class';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {ScheduleAppointmentRequestDTO} from '../../dtos/service';
import {ExpertListDTO} from '../../dtos/expert';
import {NgForm} from '@angular/forms';
import {addDays, addMonths, format} from 'date-fns';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-modal-create-appointment',
  templateUrl: './modal-create-appointment.component.html',
  styleUrls: ['./modal-create-appointment.component.scss'],
  animations: [fadeInAnimation],
  providers: [DatePipe]
})
export class ModalCreateAppointmentComponent implements OnInit, OnChanges, OnDestroy {
  @Input() clinicId: string;
  @Input() isVisibleModal: boolean;
  @Input() userType: 'expert' | 'patient';
  @Input() expert: IExpert;
  @Input() hasDefaultHour: boolean;
  @Input() selectedDate: Date;

  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Variables para los componentes que hacen referencia
  @ViewChild(ModalAddPatientAppointmentComponent) modalAddPatientAppointmentComponent: ModalAddPatientAppointmentComponent;
  @ViewChild(ModalAddExpertAppointmentComponent) modalAddExpertAppointmentComponent: ModalAddExpertAppointmentComponent;
  @ViewChild(DateComponent) dateComponent: DateComponent;

  @ViewChild('formAppointment') formAppointment: NgForm;

  patient$: Observable<IPatient> = this.store.select<IPatient>(PatientState.getSelectedPatient);
  clinicBranches$: Observable<IClinicBranch[]> = this.store.select<IClinicBranch[]>(ClinicBranchState.getClinicBranches);
  scheduleAvailability$: Observable<IGeneratedBlocks> = this.store.select<IGeneratedBlocks>(AppointmentState.getScheduleAvailability);
  objectives$: Observable<IClinicalObjective[]> = this.store.select<IClinicalObjective[]>(ClinicState.getObjectives);

  isVisibleAddPatientsModal: boolean;
  isVisibleSelectExpertModal: boolean;
  buttonSkipAssistants: boolean;
  openedModalAddPatients: boolean;

  selectedDateAux: Date;
  reasonForConsultation: string;
  initDate: Date;
  timeZone: string;
  branchOffice: IClinicBranch;
  branchOfficeId: string;
  urlSession: { url: '' };

  notesSession: string;
  consultationTypes: ICardIconText[];
  consultationTypeSelected = '';
  assistants: IPatient[] = [];
  assistantsExtra: IPatient[] = [];
  experts: ICardIconText[];
  expertSelected: ExpertListDTO;
  itemsCardAppointment: ICardDateAppointment[] = [];
  itemDateSelected;
  spotSelected: number;
  hourSelected: Date;
  hourSelectedEnd: Date;
  durations = [];
  durationSelected = 30;
  stepSection = 1;
  currentStepSection = 1;
  timeZones: string[];
  helperValidationField: HelperValidationField;
  URLSessionValid: boolean;
  isToday: boolean;
  patient: IPatient;
  viewTimeZoneExpert: boolean;
  clinicalObjectives: IClinicalObjective[] = [];
  patientClinicalObjectives: string[] = [];
  clinicalObjectivesSubscription: Subscription;
  platformConfig = PLATFORM_CONFIG;
  constructor(
    private datePipe: DatePipe,
    private store: Store,
    public utilitiesServices: UtilitiesService,
    public messageAlertService: MessageAlertService,
    public appTourService: AppTourService
  ) {
    this.clinicalObjectivesSubscription = this.objectives$.subscribe(data => {
      if (data) {
        this.clinicalObjectives = [...data];
      }
    });
  }

  ngOnInit(): void {
    this.initValues();
  }

  initValues(): void {
    this.branchOffice = null;
    this.urlSession = {
      url: ''
    };
    this.helperValidationField = new HelperValidationField();
    this.URLSessionValid = false;
    this.buttonSkipAssistants = true;
    this.assistantsExtra = [];
    this.assistants = [];
    this.initDate = new Date();
    // Tipos de conusultas
    this.consultationTypes = [
      {
        id: 'presential',
        label: 'Presencial',
        img: './../../../assets/images/icons/icons8-sitting-on-chair-100.png'
      },
      {
        id: 'online',
        label: 'En línea',
        img: './../../../assets/images/icons/icons8-video-call-100.png'
      }
    ];
    // Tipos de días predefinidos
    this.itemsCardAppointment = [
      {
        id: 'now',
        title: 'Iniciar ahora',
        dateText: format(new Date(), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-planner-100.png'
      },
      {
        id: 'tomorrow',
        title: 'Mañana',
        dateText: format(addDays(new Date(), 1), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-morning-100.png'
      },
      {
        id: 'week',
        title: 'Una semana',
        dateText: format(addDays(new Date(), 7), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-plus-1-week-100.png'
      },
      {
        id: '15days',
        title: 'En 15 días',
        dateText: format(addDays(new Date(), 14), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-calendar-15-100.png'
      },
      {
        id: 'month',
        title: 'Un mes',
        dateText: format(addMonths(new Date(), 1), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-plus-1-month-100.png'
      },
      {
        id: 'other',
        title: 'Otra fecha',
        dateText: format(new Date(), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-date-from-100.png'
      }
    ];
    // Duraciones disponibles
    this.durations = [
      {
        id: '60',
        label: '60 MIN',
        value: 60
      },
      {
        id: '30',
        label: '30 MIN',
        value: 30
      }
    ];

    this.timeZones = timeZonesData.nameTimeZones();
  }

  // tslint:disable:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.expert && changes.expert.currentValue !== null && this.expert) {
      this.expertSelected = {
        name: this.expert.user?.name,
        lastname: this.expert.user?.lastname,
        _id: this.expert._id,
        email: this.expert.user?.email,
        gender: this.expert.user?.gender,
        profileImageURL: this.expert.user?.profileImageURL,
        specializationId: this.expert.specializationId,
        specializationName: this.expert.specializationName,
        timeZone: this.expert.user?.timeZone,
        userId: this.expert.user?._id
      };
      this.timeZone = this.utilitiesServices.getTimeZoneBrowser();
      // Para elegir por defecto la sucursal del experto que va a crear la consulta
      this.branchOfficeId = this.expert.clinicBranchId ? this.expert.clinicBranchId : null;
    }
    // Si se le pasa la fecha y hora
    if (!changes.selectedDate) return;
    if (this.selectedDate) {
      this.selectedDateAux = cloneDeep(this.selectedDate);
    }
  }

  /**
   * Al cerrar este modal
   * @param emit acción del modal
   */
  onCloseModal(emit: boolean): void {
    // this.resetModal();
    this.closeModal.emit(emit);
  }

  /**
   * Al cambiar el tipo de consulta
   */
  async onChangeConsultationType(type): Promise<void> {
    this.patient = await firstValueFrom((this.patient$.pipe(take(1))));
    this.branchOfficeId = this.expert ? (this.expert.clinicBranchId ? this.expert.clinicBranchId : null) : null;
    // this.branchOffice = null;
    if (type.id === this.consultationTypeSelected) {
      return;
    }
    this.consultationTypeSelected = type.id;

    if ((this.userType !== 'patient' && this.assistants.length > 0) || this.userType === 'patient') {
      if (this.userType === 'patient' && this.consultationTypeSelected === 'online') {
        this.currentStepSection = 5;
      } else {
        if (this.branchOfficeId) { // si el experto tiene clinicBranchId y ya se coloco en this.branchOfficeId
          const branches = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicBranchState.getClinicBranches))));
          // ir al metodo caundo se elige una sucursal, pero de forma manual ya que hay opcion de sucursal seleccionada por defecto
          this.onChangeBranch(this.branchOfficeId, branches);
        }
        this.currentStepSection = 4;
      }
    } else {
      if (this.branchOfficeId && this.patient) {
        // ir al metodo caundo se elige una sucursal, pero de forma manual ya que hay opcion de sucursal seleccionada por defecto
        const branches = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicBranchState.getClinicBranches))));
        this.onChangeBranch(this.branchOfficeId, branches);
        this.currentStepSection = 5;
      } else {
        this.currentStepSection = 3;
      }
    }
    if (this.stepSection < this.currentStepSection) {
      // Si estaba en paso 1 (iniciando), desbloquear el this.currentStepSection
      this.stepSection = this.currentStepSection;
    } else {
      // Comparar a qué cambia, si hay datos obligatorios por completar, bloquear el contenido posterior hasta llenarlos
      if (this.stepSection >= this.currentStepSection) {
        if (this.userType === 'patient' && this.consultationTypeSelected === 'online' && this.stepSection === 4) {
          this.stepSection = 5;
        }
        this.checkPreviousSteps();
      }
    }
  }

  /**
   * Al quitar el focus del input, pasa al siguiente paso, siempre y cuando no sea null o vacío
   * @param event event
   */
  /*onBlurReasonForConsultation(event): void {
    this.currentStepSection = 2;
    if (event.target.value) {
      if (this.stepSection < 4 && this.userType === 'patient') {
        if (this.consultationTypeSelected === 'presential') {
          this.goToStep(4);
        } else {
          this.goToStep(5);
        }
        /!* } else if (this.stepSection < 3) {
          this.goToStep(3); *!/
        // Se añadió esto para máximo un paciente
      } else if (this.userType !== 'patient') {
        if (!this.patient) {
          if (this.stepSection < 3) {
            this.goToStep(3);
          } else {
            this.checkPreviousSteps();
          }
        } else {
          if (this.stepSection < 4) {
            this.goToStep(4);
          } else {
            this.checkPreviousSteps();
          }
        }
        // Fin modificación para máximo un paciente

      } else {
        this.checkPreviousSteps();
      }
    } else {
      this.checkPreviousSteps();
    }
  }*/

  /**
   * Omite la selección de asistentes para pasar al siguiente paso.
   * Aunque se pueden añadir asistentes incluso si se le dio en omitir
   * @param reset indica si se reinicia el arreglo de asistentes
   */
  async onSkipAssistant(reset: boolean): Promise<void> {
    // Ir al paso 4 o 5 si se está en el paso 3 y dependiendo del tipo de usuario
    if (this.userType === 'expert') {
      if (this.stepSection < 4) {
        // Ir al paso 4
        this.goToStep(4);
      } else {
        this.checkPreviousSteps();
      }
    } else if (this.userType === 'patient') {
      if (this.stepSection < 4) {
        if (this.consultationTypeSelected === 'online') {
          // Ir al paso 5
          this.goToStep(5);
        } else {
          // Ir al paso 4
          this.goToStep(4);
        }
      }
    }
    if (reset) {
      const patient = await firstValueFrom((this.patient$.pipe(take(1))));
      this.resetAssistants(patient);
    }
    this.buttonSkipAssistants = false;
  }

  /**
   * Al elegir una sucursal
   */
  onChangeBranch(branchId: string, branches: IClinicBranch[]): void {
    this.currentStepSection = 4;
    this.branchOffice = branches.find(item => item._id === branchId);

    // si se elije otra sucursal limpiar el experto para elegir uno nuevo del modal de expertos
    if (this.userType === 'patient') {
      this.expertSelected = null;
      this.timeZone = null;
    }
    // Si es experto ir al paso 6, si es paciente ir al paso 5
    if (this.userType === 'expert') {
      if (this.stepSection < 6) {
        if (this.consultationTypeSelected === 'presential') {
          this.goToStep(6);
        }
      } else {
        this.checkPreviousSteps();
      }
    } else if (this.userType === 'patient') {
      if (this.stepSection < 5) {
        this.goToStep(5);
      } else {
        this.checkPreviousSteps();
      }
    }
  }


  onClickBranch(branchId: string, branches: IClinicBranch[]): void {
    this.onChangeBranch(this.branchOfficeId, branches);
  }

  /**
   * Al terminar de colocar la URL, valida que sea correcta (después de que se quita el focus)
   */
  onBlurURLSession(event, value, field): Promise<void> {
    this.helperValidationField.onCheckURL(value, field);
    this.helperValidationField.onValidateURL(value.url, field);
    this.URLSessionValid = field.valid;

    if (!event.target.value || !this.URLSessionValid) {
      this.currentStepSection = 4;
      this.checkPreviousSteps();
      return;
    }
    this.currentStepSection = 4;
    if (this.userType === 'expert') {
      if (this.stepSection < 6) {
        this.goToStep(6);
      } else {
        this.checkPreviousSteps();
      }
    } else {
      if (this.stepSection < 5) {
        this.goToStep(5);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  /**
   * Validador para la URL válida
   */
  onValidateURL(value, field): void {
    this.helperValidationField.onValidateURL(value, field);
    this.URLSessionValid = field.valid;
  }

  /**
   * Al seleccionar experto.
   * @param expert experto a seleccionar
   */
  async onSelectExpert(expert: ExpertListDTO): Promise<void> {
    // Experto seleccionado
    this.expertSelected = expert;
    /*
    // Poner su timeZone por default (si es que tiene)
    if (this.expertSelected && this.expertSelected && this.expertSelected.timeZone) {
      this.timeZone = this.expertSelected.timeZone;
    }
    */

    // poner la zona horaria del navegador
    if (this.utilitiesServices.getTimeZoneBrowser()) {
      this.timeZone = this.utilitiesServices.getTimeZoneBrowser();
    }
    if (this.stepSection < 6) {
      this.goToStep(6);
    } else {
      this.checkPreviousSteps();
    }
    // Acción para traer la disponibilidad del experto (si también se tiene día y hora)
    await this.getScheduleAvailable();
  }

  /**
   * Al seleccionar un bloque predefinido para la fecha o el bloque de fecha personalizada
   * @param block Bloque que indica el tipo de día seleccionado
   */
  async onSelectDate(block: ICardDateAppointment): Promise<void> {
    if (block.id === this.itemDateSelected) {
      return;
    }
    // poner la zona horaria del navegador
    if (this.utilitiesServices.getTimeZoneBrowser()) {
      this.timeZone = this.utilitiesServices.getTimeZoneBrowser();
    }
    this.itemDateSelected = block.id;
    this.currentStepSection = 6;

    // Si es "Iniciar ahora"
    if (block.id === 'now') {
      this.selectedDate = null;
      this.hourSelected = null;
      this.initDate = null;
      // Ir al paso 8 (fin)
      if (this.stepSection < 8) {
        this.goToStep(8);
      } else {
        this.checkPreviousSteps();
      }
      return;
    }

    // Asignar fecha elegida
    if (block.id !== 'other') {
      if (block.id === 'tomorrow') {
        this.selectedDate = new Date();
        this.selectedDate.setDate(new Date().getDate() + 1);
      } else if (block.id === 'week') {
        this.selectedDate = new Date();
        this.selectedDate.setDate(new Date().getDate() + 7);
      } else if (block.id === '15days') {
        this.selectedDate = new Date();
        this.selectedDate.setDate(new Date().getDate() + 14);
      } else if (block.id === 'month') {
        this.selectedDate = new Date();
        this.selectedDate.setMonth(new Date().getMonth() + 1);
      }
      this.initDate = this.selectedDate;
      this.selectedDate.setHours(0);
      this.selectedDate.setMinutes(0);
      this.selectedDate.setSeconds(0);
      await this.getScheduleAvailable();

      // Ir al paso 7
      if (this.stepSection < 7) {
        this.goToStep(7);
      } else {
        this.checkPreviousSteps();
      }
    } else {
      // Fecha personalizada
      if (this.initDate) {
        // this.initDate = new Date();
        this.selectedDate = this.initDate;
        this.selectedDate.setHours(0);
        this.selectedDate.setMinutes(0);
        this.selectedDate.setSeconds(0);
      } else {
        this.initDate = new Date();
        this.selectedDate = this.initDate;
        this.selectedDate.setHours(0);
        this.selectedDate.setMinutes(0);
        this.selectedDate.setSeconds(0);
      }
      await this.getScheduleAvailable();

      if (this.initDate && this.timeZone) {
        // Ir al paso 7
        if (this.stepSection < 7) {
          this.goToStep(7);
        } else {
          this.checkPreviousSteps();
        }
      } else {
        if (this.stepSection > 7) {
          this.checkPreviousSteps();
        }
      }
    }
  }


  /**
   * Al seleccionar un día desde el calendario en disponibilidad
   */
  async onSelectDayFromDynamicSchedule(): Promise<void> {
    this.currentStepSection = 6;
    this.itemDateSelected = 'other';
    this.initDate = this.dateComponent.selectedDate;
    this.itemsCardAppointment.find(item => item.id === 'other').dateText = this.datePipe.transform(this.initDate, 'dd/MM/yyyy');
    this.selectedDate = cloneDeep(this.initDate);
    this.selectedDate.setHours(0);
    this.selectedDate.setMinutes(0);
    this.selectedDate.setSeconds(0);
    await this.getScheduleAvailable();
    this.checkPreviousSteps();
  }

  /**
   * Al seleccionar un bloque de duración (en minutos)
   * @param duration Bloque para la duración elegida
   */
  async onSelectDuration(duration): Promise<void> {
    if (duration.id !== this.durationSelected) {
      // Valor numérico de la duración en minutos
      this.durationSelected = duration.value;

      this.currentStepSection = 6;

      await this.getScheduleAvailable();

      if (this.itemDateSelected) {
        if (this.itemDateSelected !== 'other' || (this.itemDateSelected === 'other' && this.initDate && this.timeZone)) {
          // Ir al paso 5
          if (this.stepSection < 7) {
            this.goToStep(7);
          } else {
            this.checkPreviousSteps();
          }
        }
      }

    }
  }

  /**
   * Al seleccionar un día personalizado desde el select
   * @param date Fecha elegida
   */
  async onSelectCustomDate(date): Promise<void> {
    this.selectedDate = date;
    this.selectedDate.setHours(0);
    this.selectedDate.setMinutes(0);
    this.selectedDate.setSeconds(0);
    this.itemsCardAppointment.find(item => item.id === 'other').dateText = this.datePipe.transform(this.initDate, 'dd/MM/yyyy');
    this.currentStepSection = 6;

    await this.getScheduleAvailable();

    if (this.timeZone && this.durationSelected) {
      if (this.stepSection < 7) {
        this.goToStep(7);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  /**
   * Al seleccionar un timeZone (select)
   * @param _ timeZone
   */
  async onSelectTimezone(_: string): Promise<void> {
    this.currentStepSection = 6;

    await this.getScheduleAvailable();

    if (this.initDate && this.durationSelected) {
      if (this.stepSection < 7) {
        this.goToStep(7);
      } else {
        this.checkPreviousSteps();
      }
    }

  }

  /**
   * Al elegir un bloque para la hora
   * @param spot Bloque que indica la hora elegida
   */
  async onSelectHour(spot: IAvailableSpot): Promise<void> {
    if (spot.available && this.spotSelected !== spot.startSystem) {
      this.spotSelected = spot.startSystem;
      this.hourSelected = new Date();
      const hour = Math.trunc(spot.startSystem / 60);
      const minutes = (spot.startSystem % 60);
      this.hourSelected.setHours(hour);
      this.hourSelected.setMinutes(minutes);
      this.hourSelectedEnd = cloneDeep(this.hourSelected);
      this.hourSelectedEnd.setMinutes(this.hourSelected.getMinutes() + this.durationSelected);

      if (this.stepSection < 8) {
        this.goToStep(8);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  /**
   * Pasa al paso que se le pasa en su parámetro (1 por default)
   * @param step paso al cuál se irá
   */
  goToStep(step = 1): void {
    if (this.stepSection < step) {
      this.stepSection = step;
    }
    if (this.currentStepSection < step) {
      this.currentStepSection = step;
    }

    // Para fecha y hora pre-seleccionada
    if (step === 6 && this.selectedDateAux) {
      this.selectDateAndHour();
    }
  }

  /**
   * Selecciona el día y la hora si se tienen preseleccionadas
   */
  async selectDateAndHour(): Promise<void> {
    // Se compara la fecha de hoy con la fecha elegida, para saber en qué bloque entra (mañana, en una semana, etc.)
    this.initDate = this.selectedDate;
    // initDateAux = fecha elegida, se establece la hora en 0
    const initDateAux: Date = cloneDeep(this.initDate);
    initDateAux.setHours(0, 0, 0, 0);
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    // Variables para determinar en qué bloque le corresponde, se establece en cada su respectivo tiempo a aumentar,
    // por ejemplo, para mañana se le suma +1 día a hoy, para la próxima semana se le suman +7 días a hoy, etc.
    // Es importante que también se le coloquen las horas en 0 para que se comparen con getTime()
    const tomorrow: Date = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    const nextWeek: Date = cloneDeep(tomorrow);
    const next2Weeks: Date = cloneDeep(tomorrow);
    const next2Month: Date = cloneDeep(tomorrow);
    tomorrow.setDate(tomorrow.getDate() + 1);
    nextWeek.setDate(nextWeek.getDate() + 7);
    next2Weeks.setDate(next2Weeks.getDate() + 14);
    next2Month.setMonth(next2Month.getMonth() + 1);

    // If para indicar el correspondiente bloque
    if (tomorrow.getTime() === initDateAux.getTime()) {
      // Mañana
      await this.onSelectDate(this.itemsCardAppointment.find(item => item.id === 'tomorrow'));
    } else if (nextWeek.getTime() === initDateAux.getTime()) {
      // 1 semana
      await this.onSelectDate(this.itemsCardAppointment.find(item => item.id === 'week'));
    } else if (next2Weeks.getTime() === initDateAux.getTime()) {
      // 15 dias
      await this.onSelectDate(this.itemsCardAppointment.find(item => item.id === '15days'));
    } else if (next2Month.getTime() === initDateAux.getTime()) {
      // Un mes
      await this.onSelectDate(this.itemsCardAppointment.find(item => item.id === 'month'));
    } else {
      // Otra fecha
      await this.onSelectDate(this.itemsCardAppointment.find(item => item.id === 'other'));
      this.itemsCardAppointment.find(item => item.id === 'other').dateText = this.datePipe.transform(this.initDate, 'dd/MM/yyyy');
    }
    // Establecer hora que se eligió en el calendario (modo semana o día, porque en modo mes no se elige hora)
    if (this.hasDefaultHour) {
      const availability = await firstValueFrom((this.scheduleAvailability$.pipe(take(1))));
      const spots: IAvailableSpot[] = availability?.spots ?? [];
      const selectedDateAux: Date = cloneDeep(this.selectedDateAux);
      if (spots.length > 0) {
        const spotSelected = spots.find(spot =>
          spot.startSystem === (selectedDateAux.getHours() * 60) + (selectedDateAux.getMinutes() === 30 ? 30 : 0));
        if (spotSelected) {
          await this.onSelectHour(spotSelected);
        } else {
          this.messageAlertService.createMessage('warning', 'No hay citas disponibles para la hora seleccionada. Puedes elegir cualquier otra hora.', 7000);
        }
      }
    }
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Checa que los campos previos al paso actual sean cumplidos
   * Pasos:
   * 1. Elegir tipo de consulta
   * // 2. Escribir motivo de consulta (OMITIDO)
   * 3. Elegir asistentes (u omitir)
   * 4. Seleccionar sucursal o ingresar URL en formato válido
   * 5. Seleccionar experto (para los pacientes)
   * 6. Seleccionar fecha (día) y duración
   * 7. Seleccionar bloque para la hora
   *
   *  stepSection: siempre aumenta conforme se avanza
   *  currentStepSection: sirve para poner como disabled los pasos siguentes si me regreso (Es el paso en el que  me muevo [avanzo o retrosedo])
   */
  checkPreviousSteps(): void {
    if (this.stepSection > this.currentStepSection) {
      let currentStep = 1;
      for (let step = this.currentStepSection; step <= this.stepSection; step++) {
        currentStep = step;

        // PASO 3
        // Motivo de consulta como obligatorio (OMITIDO)
        if (step === 2) {
          if (!this.reasonForConsultation) {
            // break;
          }
        }

        // PASO 3
        // Que exista el paciente y puede no llevar asistentes, o s
        if (step === 3) {
          if (this.userType !== 'patient') {
            if (this.assistants.length === 0 && !this.patient) {
              break;
            }
          }
        }

        // PASO 4
        // Sucursal elegida para presencial, para online y expertos URL de la sesión y en formato válido
        if (step === 4) {
          // Checar campos de URL para online o sucursal para presencial
          if (this.userType === 'expert') {
            if (this.consultationTypeSelected === 'online') {
              if (!this.urlSession.url || !this.URLSessionValid) {
                break;
              }
            } else if (this.consultationTypeSelected === 'presential') {
              if (!this.branchOffice) {
                break;
              }
            }
          } else if (this.userType === 'patient') {
            if (this.consultationTypeSelected === 'presential') {
              if (!this.branchOffice) {
                break;
              }
            }
          }
        }

        // PASO 5
        // Para pacientes: Experto elegido
        if (step === 5) {
          if (this.userType === 'patient') {
            if (!this.expertSelected) {
              break;
            }
          }
        }

        // PASO 6
        // Item de fecha seleccionado y duración obligatoria; si item de fecha == other,
        //  asegurarse que se tenga fecha y zona horaria
        if (step === 6) {
          if (this.userType === 'expert') {
            if (!this.itemDateSelected || !this.durationSelected) {
              break;
            }
            if (this.itemDateSelected === 'other' && (!this.initDate || !this.timeZone)) {
              break;
            }
          } else if (this.userType === 'patient') {
            if (!this.itemDateSelected || (this.itemDateSelected === 'other' && (!this.initDate || !this.timeZone))) {
              break;
            }
          }
        }

        // PASO 7
        // Hora seleccionada
        if (step === 7) {
          if (this.hourSelected === null && this.itemDateSelected !== 'now') {
            break;
          }
        }

      }

      this.currentStepSection = currentStep;
    }
  }

  /**
   * Resetea el modal para empezar desde el paso 1
   */
  async resetModal(): Promise<void> {
    this.currentStepSection = 1;
    this.stepSection = 1;
    this.reasonForConsultation = null;
    this.consultationTypeSelected = null;
    this.branchOffice = null;
    this.branchOfficeId = this.expert ? (this.expert.clinicBranchId ? this.expert.clinicBranchId : null) : null;
    this.urlSession.url = '';
    this.URLSessionValid = false;
    this.notesSession = null;
    if (this.userType === 'patient') {
      this.expertSelected = null;
      this.timeZone = null;
    }
    this.itemDateSelected = '';
    this.durationSelected = 30;
    this.initDate = null;
    this.selectedDate = null;
    this.hourSelected = null;
    this.hourSelectedEnd = null;
    this.spotSelected = null;
    this.assistants = [];
    this.assistantsExtra = [];
    this.buttonSkipAssistants = true;
    this.openedModalAddPatients = false;
    this.modalAddExpertAppointmentComponent.selectedExpert = null;
    this.modalAddPatientAppointmentComponent.selectedAssistants = [];
    this.modalAddPatientAppointmentComponent._selectedAssistantsAux = [];
    this.modalAddPatientAppointmentComponent.selectedUsersAppointment = [];
    this.patientClinicalObjectives = [];
    this.reasonForConsultation = '';
    this.clinicalObjectives = [...await firstValueFrom(this.objectives$.pipe(take(1)))];
  }

  /**
   * Devuelve la estructura de la cita para enviar al servidor (IAppointmentSchedule structure)
   */
  async getValue(): Promise<ScheduleAppointmentRequestDTO> {
    const typeOfAppointment: AppointmentTypeEnum =
      this.consultationTypeSelected === 'online' ? AppointmentTypeEnum.ONE_TO_ONE : AppointmentTypeEnum.ON_SITE;

    const cloneDate = cloneDeep(this.selectedDate) ?? new Date();
    const date: IDateInterface = {
      year: cloneDate?.getFullYear(),
      month: cloneDate?.getMonth(),
      day: cloneDate?.getDate(),
      hours: this.hourSelected?.getHours() ?? new Date().getHours(),
      minutes: this.hourSelected?.getMinutes() ?? new Date().getMinutes()
    };
    const assistants = cloneDeep(this.assistants);
    const patientSelected = await firstValueFrom((this.patient$.pipe(take(1))));
    const patientIds: string[] = assistants.map(patient => patient._id);
    if (this.userType === 'patient') {
      const mePatient = await firstValueFrom((this.patient$.pipe(take(1))));
      if (mePatient) {
        patientIds.push(mePatient._id);
      }
    }
    if (this.assistants.length === 0 && patientSelected) {
      if (!patientIds.find(item => item === patientSelected._id)) {
        patientIds.push(patientSelected._id);
      }
    }
    return {
      expertId: this.expertSelected._id,
      timeZoneExpertOverride: this.timeZone ? encodeURIComponent(this.timeZone) : void 0,
      type: typeOfAppointment,
      date,
      meetUrl: this.urlSession.url ? this.urlSession.url : '',
      meetNote: this.notesSession ? this.notesSession : '',
      duration: this.durationSelected,
      patientIds,
      clinicId: this.clinicId,
      clinicBranchId: typeOfAppointment === AppointmentTypeEnum.ON_SITE ? this.branchOfficeId : '',
      note: '',
      // appointmentClinicObjectives: this.patientClinicalObjectives.map(item => item._id),
      appointmentClinicObjectives: this.patientClinicalObjectives,
      appointmentPatientObjective: this.reasonForConsultation ?? ''
    };
  }

  /**
   * Abre el modal para añadir asistentes
   */
  async openAddAssistentModal(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    const filter = this.utilitiesServices.filterCountPagination(1, 10);
    await firstValueFrom((this.store.dispatch(new ClinicActions.GetPatientAssistants(this.clinicId, '', filter))));
    await firstValueFrom((this.store.dispatch(new PatientAction.CountByClinicId(this.clinicId, '', ''))));
    const patient = await firstValueFrom((this.patient$.pipe(take(1))));
    // Sóla primera vez desde que se abre el modal de cita
    if (!this.openedModalAddPatients) {
      this.openedModalAddPatients = true;
      this.resetAssistants(patient);
    }
    this.isVisibleAddPatientsModal = true;
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Reinicia la arreglo de los asistentes
   */
  resetAssistants(patient: IPatient): void {
    if (patient) {
      this.modalAddPatientAppointmentComponent.selectedAssistants = [patient._id];
      this.modalAddPatientAppointmentComponent.selectedUsersAppointment = [{ ...patient, skip: true }];
    } else {
      this.modalAddPatientAppointmentComponent.selectedAssistants = [];
    }
    this.modalAddPatientAppointmentComponent._selectedAssistantsAux =
      cloneDeep(this.modalAddPatientAppointmentComponent.selectedAssistants);
    this.modalAddPatientAppointmentComponent._selectedUsersAppointmentAux =
      cloneDeep(this.modalAddPatientAppointmentComponent.selectedUsersAppointment);
    const assistants: IPatient[] = cloneDeep(this.modalAddPatientAppointmentComponent.selectedUsersAppointment);
    this.assistants = assistants;
    this.assistantsExtra = assistants.filter(assistant => !assistant.skip);
    Logger.log('asistentes', this.assistantsExtra, this.assistants);
  }

  /**
   * Agregar pacientes (asistentes) y/o cerrar modal
   */
  async closeAddAssistantModal(action: boolean): Promise<void> {
    if (!action) {
      this.isVisibleAddPatientsModal = false;
      return;
    }
    // colocar el clinicBranchId
    this.branchOfficeId = this.expert ? (this.expert.clinicBranchId ? this.expert.clinicBranchId : null) : null;
    const assistants: IPatient[] = cloneDeep(this.modalAddPatientAppointmentComponent.selectedUsersAppointment);
    this.assistants = assistants;
    this.assistantsExtra = assistants.filter(assistant => !assistant.skip);
    if (this.assistantsExtra.length === 0) {
      this.currentStepSection = 3;
    }
    await this.onSkipAssistant(false);

    if (this.branchOfficeId) { // si el experto tiene clinicBranchId y ya se coloco en this.branchOfficeId
      const branches = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicBranchState.getClinicBranches))));
      // ir al método cuando se elige una sucursal, pero de forma manual, ya qué hay opción de sucursal seleccionada por defecto
      this.onChangeBranch(this.branchOfficeId, branches);
    }
    this.isVisibleAddPatientsModal = false;
  }

  /**
   * Para quitar un asistente
   */
  onRemoveAssistant(patient): void {
    let index = this.assistantsExtra.findIndex(assistant => assistant._id === patient._id);
    if (index !== -1) {
      this.assistantsExtra.splice(index, 1);
    }
    index = this.assistants.findIndex(assistant => assistant._id === patient._id);
    if (index !== -1) {
      this.assistants.splice(index, 1);
      this.modalAddPatientAppointmentComponent.selectedAssistants.splice(index, 1);
      this.modalAddPatientAppointmentComponent._selectedAssistantsAux.splice(index, 1);
      this.modalAddPatientAppointmentComponent.selectedUsersAppointment.splice(index, 1);
      this.modalAddPatientAppointmentComponent._selectedUsersAppointmentAux.splice(index, 1);
    }
    if (this.assistantsExtra.length === 0 && !this.patient) {
      this.currentStepSection = 3;
    }
  }

  /**
   * Abre el modal para seleccionar experto
   */
  async openSelectExpertModal(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    if (this.branchOffice) {
      // si se eligio una sucursal solo devolver a los expertos de esa surcursal y clinica
      // tslint:disable:no-non-null-assertion
      await firstValueFrom((this.store.dispatch(new ClinicActions.GetExpertsByBranch(this.clinicId, this.branchOffice ? this.branchOffice!._id : null))));
      await firstValueFrom((this.store.dispatch(new ExpertAction.GetCountByBranch(this.clinicId, this.branchOffice ? this.branchOffice!._id : null, ''))));
    } else {
      await firstValueFrom((this.store.dispatch(new ClinicActions.GetExperts(this.clinicId, '', null, true))));
    }

    this.isVisibleSelectExpertModal = true;
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Seleccionar experto y/o cerrar modal
   */
  async closeSelectExpertModal(action: boolean): Promise<void> {
    if (action) {
      const expertComponente: ExpertListDTO = this.modalAddExpertAppointmentComponent.selectedExpert;
      await this.onSelectExpert(expertComponente);
    }
    this.isVisibleSelectExpertModal = false;
  }

  /**
   * Regresa los horarios del experto disponibles dada la fecha, hora y duración
   */
  async getScheduleAvailable(): Promise<void> {
    // Petición al servidor para devolver la disponibilidad
    if (this.selectedDate && this.durationSelected && this.expertSelected) {
      await firstValueFrom((this.store.dispatch(new Loader(true))));
      this.spotSelected = null;
      this.hourSelected = null;
      this.hourSelectedEnd = null;
      const today = new Date();
      const date = new Date(this.selectedDate);

      if (date.getDate() !== today.getDate() || date.getMonth() !== today.getMonth() || date.getFullYear() !== today.getFullYear()) {
        // Si no es hoy
        this.isToday = false;
      } else {
        date.setHours(new Date().getHours());
        date.setMinutes(new Date().getMinutes());
        this.isToday = true;
      }
      // date.setSeconds(0);
      await firstValueFrom(this.store.dispatch(new AppointmentActions.GetAvailableSchedules(
        this.clinicId,
        {
          year: date.getFullYear(),
          month: date.getMonth(),
          day: date.getDate(),
          hours: date.getHours(),
          minutes: date.getMinutes()
        },
        this.durationSelected,
        this.expertSelected._id,
        encodeURIComponent(this.timeZone)
      )));
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  async showWithTimeZoneExpert(timeZone: string): Promise<void> {
    if (timeZone === 'patient') {
      const patient = this.assistants[0];
      this.timeZone = patient.timeZone;
    } else {
      this.timeZone = timeZone;
    }
    this.viewTimeZoneExpert = !this.viewTimeZoneExpert;
    await this.getScheduleAvailable();
  }

  ngOnDestroy(): void {
    this.clinicalObjectivesSubscription.unsubscribe();
  }



}
